import { render } from "./EventLayout.vue?vue&type=template&id=12bcc880"
import script from "./EventLayout.vue?vue&type=script&lang=js"
export * from "./EventLayout.vue?vue&type=script&lang=js"
script.render = render

export default script